import React from "react";
import PageNavHeader from "../PageNavHeader";

const ContactNavHeader = () => (
  <PageNavHeader mobileAlign="left">
    <h1
      className="lowercase"
      style={{
        fontFamily: "Inter, sans-serif",
        fontWeight: 800,
        fontSize: "clamp(32px, 9vw, 56px)",
        lineHeight: "100%",
        letterSpacing: "-0.04em",
      }}
    >
      <span style={{ color: "#721AF0" }}>let's connect </span>
      <span style={{ color: "#FFFFFF" }}>and</span>
      <br />
      <span style={{ color: "#FFFFFF" }}>make things happen</span>
    </h1>
    <p
      className="lowercase mx-auto mt-6 md:mt-8"
      style={{
        fontFamily: "Inter, sans-serif",
        fontWeight: 400,
        fontSize: "clamp(16px, 4vw, 28px)",
        lineHeight: "140%",
        letterSpacing: "-0.04em",
        color: "#FFFFFF",
        maxWidth: "758px",
      }}
    >
      have a question or need support? we're here to help. reach out to our team anytime and we'll get back to you quickly.
    </p>
  </PageNavHeader>
);

export default ContactNavHeader;
